module.exports = __webpack_public_path__ + "img/invoice-de-male-sn.e06ee71e.png";